import React, { useState } from "react";
import { Row} from "react-bootstrap";
import JournalAdmin from "./journalAdmin";
import Collaborateur from "./collaborateur";
import ExporterJournal from "./exportJournalModal";
const JournalActivite = () => {
  const tabs = ["Administrateur", "Collaborateurs"];
       const [activeTab1, setActiveTab1] = useState("Administrateur");
        const handleTabChange = (tab1) => {
        setActiveTab1(tab1);
      };
       const [isModalOpen, setIsModalOpen] = useState(false);
  
  return (
<Row>
<div
  style={{
    marginTop: "-10px",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  }}
>
  {/* Tabs */}
  <div
    style={{
      backgroundColor: "#FFFFFF",
      color: "#000",
      padding: "5px 5px",
      display: "flex",
      borderRadius: "100px",
      gap: "8px",
    }}
  >
    {tabs.map((tab1) => (
      <div
        key={tab1}
        onClick={() => handleTabChange(tab1)}
        className={`${activeTab1 === tab1 ? "active" : ""}`}
        style={{
          backgroundColor: activeTab1 === tab1 ? "#396AFC14" : "#F5F5F5",
          color: activeTab1 === tab1 ? "#396AFC" : "#141414",
          padding: "5px 20px",
          fontFamily: "Poppins",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 400,
          fontSize: "14px",
          borderRadius: "100px",
          cursor: "pointer",
        }}
      >
        {tab1}
      </div>
    ))}
  </div>
  <button
    type="button"
    className="btn btn-primary"
    style={{
      height: "40px",
      padding: "0 10px",
      color: "#FFFFFF",
      backgroundColor: "#3761FF",
      borderColor: "#3761FF",
      borderRadius: "8px",
      fontFamily: "Poppins",
      fontSize: "15px",
      fontWeight: "500",
      boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
    }}
     onClick={() => setIsModalOpen(true)}
  >
   Exporter le journal
  </button>
</div>
  {activeTab1 === "Administrateur" && (
      <>
        <JournalAdmin/>
      </>
      )
  }
   {activeTab1 === "Collaborateurs" && (
      <>
        <Collaborateur/>
      </>
      )
  }
   <ExporterJournal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </Row>
  );
};
export default JournalActivite;
